import type { FaireProductEntity } from "../../entity_types/product";

export const p_arz9emkv7x: FaireProductEntity = {
  token: "p_arz9emkv7x",
  type: "product",
  name: "SUMMER BEACH PUKA SHELL WOVEN NECKLACE  | 80N550",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/d9f8c980696ed2336d86701e0c790ed8a42acf6df7a87b942f54438efd98403e.jpeg",
  priceDollars: 4.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/dbb2d5f306d4ab9f34fa35679d4e69c85581b80f7eb9b658d1434ad6b8123183.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
